import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fail-payment',
  templateUrl: './fail-payment.component.html',
  styleUrls: ['./fail-payment.component.scss']
})
export class FailPaymentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
